import React from 'react'
import { Link } from 'react-router-dom'
import HR from '../images/hr.svg'
import { FaCloud, FaLock, FaMobileAlt, FaDesktop } from 'react-icons/fa';
import SubserviceDetailComponent from '../components/SubserviceDetailComponent';

const services = [
    {
      icon: <FaCloud />,
      title: 'HR Information Systems (HRIS)',
      description: 'Utilize advanced HRIS to streamline HR processes, manage employee data, and generate insightful reports.',
    },
    {
      icon: <FaLock />,
      title: 'Applicant Tracking Systems (ATS)',
      description: 'Enhance your recruitment process with efficient ATS, improving candidate tracking and streamlining hiring.',
    },
    {
      icon: <FaMobileAlt />,
      title: 'Employee Self-Service Portals',
      description: 'Implement self-service portals for employees to access HR information, manage benefits, and handle administrative tasks.',
    },
  
  ];

const HRTechnology = () => {
  return (
    <div>
       <div className = "relative">
      <img
        className="h-auto w-full object-cover"
        src={HR}
        alt="HR Services"
      />

      <div>

      <section className='text-left mt-6'>
      <h1 className="text-center my-6 text-2xl font-semibold">HR Technology & Systems</h1>
      </section>
     

      <section>
        <SubserviceDetailComponent services={services}/>
        <div className='mb-6'>
      <h2 className="text-xl font-semibold mb-6 mx-6">Get Started with Expert HR Services</h2>
      <p className="text-md text-black mb-6 px-12 text-left">
      Maximize efficiency, enhance security, and drive growth with our tailored HR Services. Our certified experts provide 24/7 support, proactive monitoring, and strategic HR planning to meet your business needs.
      </p>
      
      <Link to="/contact"
        className="inline-block bg-[#13689b] text-white py-3 px-6 rounded-md text-md font-semibold transition-transform transform hover:scale-105">
      Contact Us
      </Link>
     
      </div>
      </section>

    </div>

    </div>
    </div>
  )
}

export default HRTechnology
